"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _OutageInfobox = _interopRequireDefault(require("./OutageInfobox"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PaginationControl = function PaginationControl(props) {
  var currentIndex = props.currentIndex,
      numElements = props.numElements,
      setCurrentIndex = props.setCurrentIndex;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'pagination-control'
  }, /*#__PURE__*/_react.default.createElement("button", {
    title: 'Previous Outage',
    disabled: currentIndex - 1 < 0,
    onClick: function onClick() {
      if (currentIndex - 1 >= 0) setCurrentIndex(currentIndex - 1);
    },
    className: "".concat(currentIndex === 0 ? 'hidden' : '')
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'caret-left']
  })), /*#__PURE__*/_react.default.createElement("span", null, currentIndex + 1, " of ", numElements), /*#__PURE__*/_react.default.createElement("button", {
    title: 'Next Outage',
    disabled: currentIndex + 1 >= numElements,
    onClick: function onClick() {
      if (currentIndex + 1 < numElements) setCurrentIndex(currentIndex + 1);
    },
    className: "".concat(currentIndex + 1 === numElements ? 'hidden' : '')
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: ['fas', 'caret-right']
  })));
};

var PaginatedOutageInfobox = function PaginatedOutageInfobox(props) {
  var desc = props.outage.desc;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentOutageIndex = _useState2[0],
      setCurrentOutageIndex = _useState2[1];

  (0, _react.useEffect)(function () {
    setCurrentOutageIndex(0);
  }, [desc]);

  if (!desc.outages || desc.outages.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_OutageInfobox.default, {
      outage: props.outage,
      bounds: props.bounds,
      infoboxBodyMethod: props.infoboxBodyMethod,
      infoboxFooterMethod: props.infoboxFooterMethod
    });
  } //build outage prop


  var selectedOutage = Object.assign({}, _objectSpread(_objectSpread({}, props.outage), {}, {
    desc: desc.outages[currentOutageIndex] || desc
  }));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'pagination-container'
  }, /*#__PURE__*/_react.default.createElement(PaginationControl, {
    currentIndex: currentOutageIndex,
    numElements: desc.outages.length,
    setCurrentIndex: function setCurrentIndex(nextIndex) {
      return setCurrentOutageIndex(nextIndex);
    }
  }), /*#__PURE__*/_react.default.createElement(_OutageInfobox.default, {
    outage: selectedOutage,
    bounds: props.bounds,
    infoboxBodyMethod: props.infoboxBodyMethod,
    infoboxFooterMethod: props.infoboxFooterMethod
  }));
};

var _default = PaginatedOutageInfobox;
exports.default = _default;